/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './subscribeRepos.defs.js'
export { main as default } from './subscribeRepos.defs.js'
